import { Container } from '../../components';
import System1 from '../../public/mvp/system1.svg';
import System2 from '../../public/mvp/system2.svg';
import System3 from '../../public/mvp/system3.svg';
import System4 from '../../public/mvp/system4.svg';
import MvpCard from './mvp-card';
import styles from './mvp-expertise.module.css';
import commonStyles from './mvp.module.css';

const cards = [
  {
    id: 1,
    icon: <System1 className={styles.icon} />,
    title: 'Product Engineering',
    description: [
      'iOS (Swift) and Android (Kotlin) development',
      'Web apps with React JS and Next JS',
      'API Design & development',
      'AI & Claude Code for faster, more efficient development',
    ],
  },
  {
    id: 2,
    icon: <System2 className={styles.icon} />,
    title: 'UX/UI & Rapid Prototyping',
    description: [
      'UX research and wireframing',
      'Beautiful UI design that fits your brand',
      'Fast interactive prototypes for early feedback',
      'AI-powered tools to accelerate ideation and prototyping',
    ],
  },
  {
    id: 3,
    icon: <System3 className={styles.icon} />,
    title: 'Testing & QA',
    description: [
      'Manual and automated testing',
      'Bug fixing and edge-case testing',
      'App store compliance checks',
    ],
  },
  {
    id: 4,
    icon: <System4 className={styles.icon} />,
    title: 'Post-Launch Support',
    description: [
      '2 weeks of included support after release',
      'Bug fixes, hot patches, and onboarding help',
      'Option to scale into v2 and full product roadmap',
    ],
  },
];

export default function MVPExpertise() {
  return (
    <section className={styles.expertise}>
      <Container>
        <div className={styles.content}>
          <h2 className={commonStyles.h2}>Tech Expertise for mvp delivery</h2>
          <p className={commonStyles.text}>
            We provide full-cycle MVP development services tailored for startups
            — from product discovery to launch — using proven native
            technologies and agile delivery. <br />
            Here’s what we bring to the table:
          </p>
        </div>
        <ul className={styles.list}>
          {cards.map((card) => (
            <li key={card.id} className={styles.item}>
              <MvpCard className={styles.card}>
                <div className={styles.card_wrapper}>
                  {card.icon}
                  <h3 className={styles.card_title}>{card.title}</h3>
                  <ul className={styles.description_list}>
                    {card.description.map((item, index) => (
                      <li key={index} className={styles.description_item}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </MvpCard>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
